import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { FaCheck } from "react-icons/fa";
import Footer from "components/Footers/Footer";
import { HashLink } from "react-router-hash-link";
import { useSize } from "components/SizeControl/SizeControl";
import { Accordion, AccordionTab } from "primereact/accordion";
import imageHeader from "../assets/ossaPictures/hakkimizdaHeader.jpeg";
import PictureHeader from "components/PictureHeader/PictureHeader";
import { useNavigate } from "react-router-dom";
import DynamicCardSection from "components/Hizmetlerimiz/DynamicCardSection";

const SigortaHukuku = () => {
  const { under1200, under992 } = useSize();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    // Sayfa yüklendiğinde .gt-lang-code elementini bul ve değişiklik yap
    const targetLink = document.querySelector('a[data-gt-lang="tr"]'); // Değiştirmeniz gereken class veya id'yi buraya ekleyin

    if (targetLink) {
      // Otomatik tıklama
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png"; // Değiştirmeniz gereken yeni resim yolunu buraya ekleyin
      console.log(imgElement);
      imgElement.src = newImgSrc;
      imgElement.width = "32";
      imgElement.height = "32";
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>SİGORTA (TAHKİM) HUKUKU | EKŞİOĞLU HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Sigorta Tahkim Komisyonu ve sigorta sözleşmesinden kaynaklanan uyuşmazlıkların tahkim yoluyla incelenmesine ilişkin genel hukuki bilgilendirme."
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/sigorta-tahkim-hukuku"
        />
        <meta
          property="og:title"
          content="SİGORTA (TAHKİM) HUKUKU | EKŞİOĞLU HUKUK"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Sigorta Tahkim Komisyonu ve sigorta sözleşmesinden kaynaklanan uyuşmazlıkların tahkim yoluyla incelenmesine ilişkin genel hukuki bilgilendirme."
        />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta property="og:url" content="https://www.eksiogluhukukofisi.com" />
      </Helmet>
      <WhiteNavbar navbarSelection={"about-us"} />

      <div className="font-sans">
        <Container style={{ marginTop: "75px" }}>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              <div className={!isMobile ? "my-6" : "my-5"}>
                <h1
                  className="font-weight-bold"
                  style={{
                    background: "linear-gradient(135deg, #0F172A, #333333)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: "2.5em",
                    marginBottom: "30px",
                  }}
                >
                  SİGORTA (TAHKİM) HUKUKU
                </h1>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto" md="6" style={{ alignContent: "center" }}>
              <img
                alt="Sözleşme ve Borçlar Hukuku"
                className="img rounded"
                src={require("assets/eksiogluPictures/hizmetler/isHukuku.webp")}
                height={540}
                width={540}
                loading="eager"
              ></img>
            </Col>
            <Col
              className="mr-auto mt-5"
              md="6"
              data-aos="zoom-in"
              data-aos-duration="2000"
              style={{ alignSelf: "center" }}
            >
              <p>
                Sigorta hukuku, sigorta sözleşmeleriyle ilgili anlaşmazlıkların
                çözümlenmesinde uygulanan hukuk dalıdır. Sigorta şirketi ve
                sigortalı arasında zaman zaman anlaşmazlıklar ortaya çıkabilir
                ve bu anlaşmazlıkların çözümü için sigorta hukuku kullanılır.
              </p>
              <br></br>
              <p>
                Sigorta sözleşmesinden doğan uyuşmazlıklar, 5684 sayılı
                Sigortacılık Kanunu uyarınca kurulan Sigorta Tahkim Komisyonu
                nezdinde tahkim yoluyla incelenebilmektedir. Uyuşmazlığın
                tahkim yoluna taşınabilmesi, ilgili mevzuatta öngörülen usul ve
                koşulların yerine getirilmesine bağlıdır.
              </p>
              <br></br>
              <p>
                Hakem kararlarına karşı başvurulabilecek kanun yolları ile
                bunlara ilişkin süre ve parasal sınırlar da aynı mevzuatta
                düzenlenmiştir.
              </p>
            </Col>
          </Row>
          <div className="title">
            <br></br>

            <h2
              className="ml-auto mr-auto text-center "
              style={{
                background: "linear-gradient(135deg, #0F172A, #333333)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>SIKÇA SORULAN SORULAR</b>
            </h2>
          </div>
          <br></br>
          <div className="card mb-4">
            <Accordion activeIndex={0}>
              <AccordionTab header="Sigorta Tahkim Komisyonunun hukuki niteliği nedir?" className="font-sans">
                <p className="m-0 font-sans text-[16px]">
                  Sigorta Tahkim Komisyonu, 5684 sayılı Sigortacılık Kanunu
                  uyarınca, sigorta sözleşmesinden kaynaklanan uyuşmazlıkların
                  tahkim yoluyla incelenmesi amacıyla kurulmuştur.
                  Uyuşmazlıklar, Komisyon nezdinde görevlendirilen sigorta
                  hakemleri tarafından değerlendirilir.
                </p>
              </AccordionTab>
              <AccordionTab header="Başvurunun usul ve koşulları nasıl belirlenir?" className="font-sans">
                <p className="m-0 font-sans text-[16px]">
                  Başvurunun şekli, süresi, sunulması gereken bilgi ve belgeler
                  ile başvuru ücretine ilişkin esaslar Sigortacılık Kanunu ve
                  ilgili mevzuatta düzenlenmiştir. Kural olarak, uyuşmazlığın
                  Komisyona taşınabilmesi için sigorta kuruluşuna daha önce
                  başvurulmuş olması aranır.
                </p>
              </AccordionTab>
              <AccordionTab header="Tahkim yoluna taraflar bizzat başvurabilir mi?" className="font-sans">
                <p className="m-0 font-sans text-[16px]">
                  Uyuşmazlığın tarafları Komisyona bizzat başvurabileceği gibi,
                  vekilleri aracılığıyla da başvuruda bulunabilir. Vekil
                  aracılığıyla temsil, Avukatlık Kanunu hükümlerine tabidir.
                </p>
              </AccordionTab>
              <AccordionTab header="Sigorta Tahkim Komisyonunun görev alanı nedir?" className="font-sans">
                <p className="m-0 font-sans text-[16px]">
                  Komisyonun görev alanı, sigorta sözleşmesinden kaynaklanan
                  uyuşmazlıklarla sınırlıdır. Taraflar arasında bir sigorta
                  ilişkisinin bulunmadığı hâllerde uyuşmazlık tahkim usulünün
                  kapsamı dışında kalır ve genel hükümlere tabi olur.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </Container>
        <DynamicCardSection />
      </div>
      <Footer />
    </>
  );
};

export default SigortaHukuku;
